import React from 'react';
import { Product } from '../../graphql/entities';
import ProductOverviewTab from '../../views/product/ProductOverviewTab';
import { useFormQuery } from '../../graphql/containers/useFormQuery';
import { EntityType } from '../../@types/entityTypes';

type IProductSidebarFormProps = {
  id: number;
  sidebar: boolean;
};

const ProductSidebarForm = ({ sidebar, id }: IProductSidebarFormProps) => {
  const formData = useFormQuery({ instance: Product.instance! } as EntityType, {
    duplicate: true,
    overrideParams: { id: id },
  });

  if (!formData?.data) {
    return null;
  }

  return <ProductOverviewTab id={id} sidebar={sidebar} formData={formData} values={{ ...formData.data }} />;
};

export default ProductSidebarForm;
